import type { UserRole } from '@/types/auth'

export type Permission = 'docs:all' | 'docs:staff' | 'docs:volunteer' | 'docs:contractor' | 'tools:normal' | 'tools:internal' | 'users:manage' | 'audit:view' | 'settings:manage'
export const rolePermissions: Record<UserRole, readonly Permission[]> = {
  admin: ['docs:all', 'docs:staff', 'docs:volunteer', 'docs:contractor', 'tools:normal', 'tools:internal', 'users:manage', 'audit:view', 'settings:manage'],
  staff: ['docs:all', 'docs:staff', 'docs:volunteer', 'tools:normal', 'tools:internal'],
  volunteer: ['docs:volunteer', 'tools:normal'],
  contractor: ['docs:contractor', 'tools:normal']
}
export function hasPermission(role: UserRole | undefined, permission: Permission) { return !!role && rolePermissions[role].includes(permission) }
export function roleCanAccess(role: UserRole, allowed: UserRole[]) { return role === 'admin' || allowed.includes(role) }
